'use client';
import { useState } from 'react';
import { Info } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { InfoModal } from '@/components/ui/InfoModal/InfoModal';

interface Props {
  partnerName: string;
  filterLabels: string[];
}

export function SelectPartnerBanner({ partnerName, filterLabels }: Props) {
  const [open, setOpen] = useState(false);
  const t = useTranslations('partner');
  const title = `${partnerName} × TONE3000`;

  if (!partnerName) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="w-full flex items-center justify-center gap-2 py-2 px-4 border-b border-zinc-800 text-sm text-zinc-300 bg-zinc-500/25"
        aria-label={t('aboutIntegration')}
      >
        <Info size={16} className="flex-shrink-0" />
        <span>{title}</span>
      </button>

      <InfoModal
        open={open}
        onClose={() => setOpen(false)}
        title={title}
        message={
          <div className="flex flex-col gap-4">
            <span className="text-zinc-400 text-sm leading-relaxed">
              {t('libraryPitch')}
            </span>
            {filterLabels.length > 0 && (
              <div className="flex flex-col gap-2">
                <span className="text-zinc-400 text-sm font-medium">{t('youreViewing')}</span>
                <ul className="flex flex-col gap-1">
                  {filterLabels.map((label) => (
                    <li key={label} className="flex items-center gap-2 text-zinc-400 text-sm">
                      <span>•</span>
                      {label}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <span className="text-zinc-400 text-sm">
              {t('forFullLibrary')}{' '}
              <a href="https://tone3000.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">
                tone3000.com
              </a>
            </span>
          </div>
        }
      />
    </>
  );
}
